// tslint:disable

import {
    GroupIdentifier, GroupDirection, IAddGroupOptions, GroupsOrder, IMergeGroupOptions,
    IEditorGroup,
    GroupsArrangement,
    GroupLocation,
    IFindGroupScope,
} from '@workbench-stack/core';
import { distinct, coalesce } from '@vscode-alt/monaco-editor/esm/vs/base/common/arrays';
import { EDITOR_DEFAULT_HEIGHT } from '../../constants';
export const DEFAULT_GROUP_ID = 1;

/**
 *
 * Has all the helpers functions to manipulate the Editor Groups. Editor group is interested in
 * EDITOR_ACTIVE, EDITOR_CLOSE, EDITOR_PIN actions.
 *
 */
const mostRecentActiveGroups: GroupIdentifier[] = [];


function updateMostRecentActive(group: IEditorGroup, makeMostRecentlyActive?: boolean) {
    const index = mostRecentActiveGroups.indexOf(group.id);

    // Remove from MRU list
    if (index !== -1) {
        mostRecentActiveGroups.splice(index, 1);
    }

    // Add to front as needed
    if (makeMostRecentlyActive) {
        mostRecentActiveGroups.unshift(group.id);
    }
}

function assertGroup(group: IEditorGroup | GroupIdentifier, groups: readonly IEditorGroup[]): IEditorGroup {
    let groupView: IEditorGroup | undefined;
    if (typeof group === 'number') {
        groupView = getGroup(group, groups);
    } else {
        groupView = group;
    }

    if (!groupView) {
        throw new Error('Invalid editor group provided!');
    }

    return groupView;
}

function doFindGroupByLocation(location: GroupLocation, source: IEditorGroup | GroupIdentifier,
    groupsStore: readonly IEditorGroup[], wrap?: boolean): IEditorGroup {
    const sourceGroupView = assertGroup(source, groupsStore);
    const groups = getGroups(GroupsOrder.GRID_APPEARANCE, groupsStore);
    const index = groups.indexOf(sourceGroupView);

    switch (location) {
        case GroupLocation.FIRST:
            return groups[0];
        case GroupLocation.LAST:
            return groups[groups.length - 1];
        case GroupLocation.NEXT:
            let nextGroup = groups[index + 1];
            if (!nextGroup && wrap) {
                nextGroup = doFindGroupByLocation(GroupLocation.FIRST, source, groupsStore);
            }

            return nextGroup;
        case GroupLocation.PREVIOUS:
            let previousGroup = groups[index - 1];
            if (!previousGroup && wrap) {
                previousGroup = doFindGroupByLocation(GroupLocation.LAST, source, groupsStore);
            }

            return previousGroup;
        default:
            return;
    }
}

// function toGridViewDirection(direction: GroupDirection): Direction {
//     switch (direction) {
//         case GroupDirection.UP: return Direction.Up;
//         case GroupDirection.DOWN: return Direction.Down;
//         case GroupDirection.LEFT: return Direction.Left;
//         case GroupDirection.RIGHT: return Direction.Right;
//         default:
//             return Direction.Right;
//     }
// }

function doFindGroupByDirection(direction: GroupDirection, source: IEditorGroup | GroupIdentifier,
    groupsStore: readonly IEditorGroup[], wrap?: boolean): IEditorGroup {
    const sourceGroupView = assertGroup(source, groupsStore);

    // // Find neighbours and sort by our MRU list
    // mostRecentActiveGroups.indexOf(n1.id) - mostRecentActiveGroups.indexOf(n2.id)

    // return neighbours[0];
    console.warn('TODO doFindGroupByDirection is not implemented, need to be implemented!');
    return doFindGroupByLocation(GroupLocation.FIRST, source, groupsStore, wrap);
}

export function findGroup(scope: IFindGroupScope,
    source: IEditorGroup | GroupIdentifier = this.activeGroup, groups: readonly IEditorGroup[], wrap?: boolean): IEditorGroup {

    // by direction
    if (typeof scope.direction === 'number') {
        return doFindGroupByDirection(scope.direction, source, groups, wrap);
    }

    // by location
    if (typeof scope.location === 'number') {
        return doFindGroupByLocation(scope.location, source, groups, wrap);
    }

    throw new Error('invalid arguments');
}

export function getActiveGroup(groups: readonly IEditorGroup[]) {
    return groups.filter(group => group.isActive).shift();
}

// tslint:disable-next-line:no-empty
export function getLabel(id: GroupIdentifier) {
}

export function getGroup(idenfifier: GroupIdentifier, groups: readonly IEditorGroup[]) {
    return groups.filter(group => group.id === idenfifier).shift();
}

export function getGroups(order: GroupsOrder = GroupsOrder.CREATION_TIME, groups: readonly IEditorGroup[]) {
    switch (order) {
        case GroupsOrder.CREATION_TIME:
            return groups;
        case GroupsOrder.MOST_RECENTLY_ACTIVE:
            const mostRecentActive = coalesce(mostRecentActiveGroups.map(groupId => getGroup(groupId, groups)));

            // there can be groups that got never active, even though they exist. in this case
            // make sure to ust append them at the end so that all groups are returned properly
            return distinct([...mostRecentActive, ...groups]);

        case GroupsOrder.GRID_APPEARANCE:
            // TODO
            return groups;

        default:
    }
}

export function arrageGroups(arrangement: GroupsArrangement, groups: readonly IEditorGroup[]) {
    if (groups.length < 2) {
        return groups; // require at least 2 groups to show;
    }

    // Even all group sizes
    if (arrangement === GroupsArrangement.EVEN) {
        // TODO
    }
    // Maximize the current active group
    else {
        // TODO
    }
    return groups;
}

export function activateGroup(group: GroupIdentifier | IEditorGroup, groups: readonly IEditorGroup[]) {
    const groupsCopy = groups.slice(0);
    const groupView = assertGroup(group, groupsCopy);
    if (getGroup(groupView.id, groups).isActive) {
        return groupsCopy; // return if this is already the active group
    }

    const previousActiveGroup = getActiveGroup(groupsCopy);
    const activeGroupIndex = indexOf(previousActiveGroup, groupsCopy);
    // Update list of most recently active groups
    updateMostRecentActive(groupView, true);
    if (previousActiveGroup) {
        groupsCopy[activeGroupIndex] = { ...previousActiveGroup, isActive: false };
    }
    const index = indexOf(groupView, groupsCopy);

    // Maximize the group if is currently minimized
    // TODO
    // if (groupView.editorLayout.width === groupView.editorLayout.minimumWidth ||
    //     groupView.editorLayout.size === groupView.editorLayout.minimumHeight) {
    //         groups = arrangeGroups(GroupsArrangement.MINIMIZE_OTHERS);
    // }

    if (index !== -1) {
        groupsCopy[index] = { ...groupsCopy[index], isActive: true };
    }
    return groupsCopy;
}

export function setGroupMode(group: GroupIdentifier | IEditorGroup, groups: readonly IEditorGroup[], mode: string) {
    const groupsCopy = groups.slice(0);
    const groupView = assertGroup(group, groupsCopy);
    if (getGroup(groupView.id, groups).isActive) {
        return groupsCopy; // return if this is already the active group
    }

    const previousActiveGroup = getActiveGroup(groupsCopy);
    const activeGroupIndex = indexOf(previousActiveGroup, groupsCopy);
    // Update list of most recently active groups
    // updateMostRecentActive(groupView, true);
    if (previousActiveGroup) {
        groupsCopy[activeGroupIndex] = { ...previousActiveGroup, isActive: false };
    }
    const index = indexOf(groupView, groupsCopy);

    if (index !== -1) {
        groupsCopy[index] = { ...groupsCopy[index], mode } as any;
    }
    return groupsCopy;
}

export function deactivateGroups(groups: readonly IEditorGroup[]) {
    const groupsCopy = groups.slice(0);

    for (let i = 0; i < groupsCopy.length; i++) {
        groupsCopy[i] = { ...groupsCopy[i], isActive: false };
    }

    return groupsCopy;
}

export function addGroup(location: GroupIdentifier, direction: GroupDirection,
    groups: readonly IEditorGroup[], options?: IAddGroupOptions) {
    let newGroup: IEditorGroup;
    let groupsCopy = groups.slice(0);
    if (groupsCopy.length === 0) {
        // empty groupsCopy
        newGroup = { id: 1, size: EDITOR_DEFAULT_HEIGHT };
        if (!options) {
            options = { activate: true };
        }
        groupsCopy.push(newGroup);
    } else {
        // get unique id
        const id = groupsCopy.length + 1; // TODO IDs can collide need to validate for any existing `id` first.
        //@sri modified below
        let newId = id;
        let groupsCopyIds = groupsCopy.map((editor) => editor.id);
        while (groupsCopyIds.includes(newId)) {
            newId = newId + 1;
        }
        newGroup = { id: newId, size: EDITOR_DEFAULT_HEIGHT };
        groupsCopy.push(newGroup);
    }
    if (options && options.activate) {
        groupsCopy = activateGroup(newGroup, groupsCopy);
    }
    return groupsCopy;
}

export function getOrCreateGroup(id: GroupIdentifier | undefined, groups: readonly IEditorGroup[], options?: IAddGroupOptions) {
    if (!id) {
        throw new Error('group id cannot be undefined');
    }
    let groupCopy = groups.slice(0); // don't modify the original array
    let group = getGroup(id, groupCopy);
    if (!groupCopy.length || !group) {
        groupCopy = addGroup(id, GroupDirection.RIGHT, groupCopy, options);
    }
    group = getGroup(id, groupCopy);
    return group;
}

export function updateGroup(group: IEditorGroup, groups: readonly IEditorGroup[]) {
    if (!group) {
        throw new Error('group need to be provided');
    }
    let groupsCopy = groups.slice(0);
    const index = indexOf(group, groupsCopy);
    if (group.isActive) { // get more preferences than others
        groupsCopy = deactivateGroups(groupsCopy);
    }
    if (index === -1) {
        // this group doesn't exist in groups so add it
        groupsCopy.push(group);
    } else {
        groupsCopy[index] = { ...groups[index], ...group };
    }

    return groupsCopy;
}

export function removeGroup(group: GroupIdentifier | IEditorGroup, groups: readonly IEditorGroup[]) {
    let groupsCopy = groups.slice(0);
    const groupView = assertGroup(group, groupsCopy);
    if (groupsCopy.length === 1) {
        return groupsCopy; // Cannot remove the last root group
    }

    // Activate next group if the removed one was active
    if (groupView.isActive) {
        const mostRecentlyActiveGroups = getGroups(GroupsOrder.MOST_RECENTLY_ACTIVE, groupsCopy);
        const nextActiveGroup = mostRecentlyActiveGroups[1]; // [0] will be the current group we are about to dispose
        groupsCopy = activateGroup(nextActiveGroup, groupsCopy);
    }
    // probably need more logic here
    // for now we doing something quick
    groupsCopy = groupsCopy.filter(val => val.id !== groupView.id);
    return groupsCopy;
}



export function moveGroup(group: GroupIdentifier, location: GroupIdentifier, direction: GroupDirection, groups: readonly IEditorGroup[]) {
    const sourceView = assertGroup(group, groups);
    const targetView = assertGroup(location, groups);

    if (sourceView.id === targetView.id) {
        throw new Error('Cannot move group into its own');
    }

    // todo

    return groups;

}

export function copyGroup(group: GroupIdentifier, location: GroupIdentifier, direction: GroupDirection, groups: readonly IEditorGroup[]) {
}

export function mergeGroup(group: GroupIdentifier, target: GroupIdentifier, groups: readonly IEditorGroup[], options?: IMergeGroupOptions) {
}

export function indexOf(candidate: IEditorGroup | null, groups: readonly IEditorGroup[]) {
    if (!candidate) {
        return -1;
    }
    for (let i = 0; i < groups.length; i++) {
        if (groups[i].id === candidate.id) {
            return i;
        }
    }
    return -1;
}
